import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadingOrganisationScopes,
  updateOrganisationScopesParams,
} from "../../redux/actions";
import { NonNullableOrganisationState } from "../../redux/state";
import { OrganisationAppBar } from "../OrganisationAppBar";
import { ScopesList } from "@ofqual/portal-organisations-scope/dist/module/presentation/scopes/ScopesList";
import { orgScopesSelector } from "../../redux/selectors";
import { Skeleton } from "@material-ui/lab";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { useSearch } from "@ofqual/portal-core/core/hooks";
import { searchFilterScopes } from "@ofqual/portal-organisations-scope/dist/module/domain/Scope";

type OrganisationScopesProps = {
  orgState: NonNullableOrganisationState;
};

export const OrganisationScopes: React.FC<OrganisationScopesProps> = ({
  orgState,
}) => {
  const { org } = orgState;
  const dispatch = useDispatch();
  const { scopes, searchParams } = useSelector(orgScopesSelector);

  const itemId = org.itemId.toString();

  useEffect(() => {
    dispatch(loadingOrganisationScopes(itemId));
  }, [dispatch, itemId]);

  const navigate = (nextParams: QueryParams) =>
    dispatch(updateOrganisationScopesParams(nextParams));

  const search = useSearch({
    searchParams,
    navigate,
  });

  const filteredScopes = scopes ? searchFilterScopes(searchParams, scopes) : [];

  return (
    <>
      <div>
        <OrganisationAppBar
          breadcrumbs={[
            { label: `${org.name}`, to: `${org.itemId}` },
            { label: "Scope of Recognition" },
          ]}
        />
        {scopes ? (
          <ScopesList scopes={filteredScopes} search={search} />
        ) : (
          <>
            <Skeleton variant="text" height={60} />
            <Skeleton variant="text" height={60} />
            <Skeleton variant="text" height={60} />
            <br />
            <Skeleton variant="rect" height={118} />
          </>
        )}
      </div>
    </>
  );
};
